import React from 'react';
import styles from './index.css';
import FloorItem from './floorItem';
class FloorList extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            content: this.props.content.basicParentList,
            isShow: false,
        };
        this.handleShowFloor = () => {
            const { isShow } = this.state;
            const { content: { basicParentList, moreParentList }, } = this.props;
            let list = [];
            if (isShow) {
                list = basicParentList;
            }
            else {
                list = basicParentList.concat(moreParentList);
            }
            this.setState({
                content: list,
                isShow: !isShow,
            });
        };
    }
    render() {
        const { content, isShow } = this.state;
        const { content: { moreParentList }, cmtVoteUrl, replyId, setReplyId, allow_comment, curPage, } = this.props;
        const bottomBarData = content.map(item => ({
            comment_id: item.comment_id,
            year: item.year,
            date: item.date,
            time: item.time,
            cmtVoteUrl,
            docUrl: item.docUrl,
            uptimes: item.uptimes,
        }));
        return (React.createElement("div", { className: styles.floor_list },
            content.map((item, index) => (React.createElement(FloorItem, { key: index, content: item, bottomBarData: bottomBarData[index], index: index, replyId: replyId, setReplyId: setReplyId, allow_comment: allow_comment, curPage: curPage }))),
            moreParentList && moreParentList.length > 0 ? (React.createElement("div", { className: styles.folder },
                React.createElement("a", { onClick: this.handleShowFloor },
                    React.createElement("span", { className: isShow ? styles.show : styles.hide }, isShow ? '收起楼层' : '展开楼层')))) : ('')));
    }
}
export default FloorList;
